<template>
  <div :class="'ui ' + this.$props.size + ' modal'" ref="generic_modal">
    <div class="ui inverted dimmer" v-bind:class="{ active: processing }">
      <div class="ui text double slow blue loader">{{ $t("loading") }}</div>
    </div>
    <i class="close icon"></i>
    <div class="icon header">
      <i :class="this.$props.icon + ' icon'"></i>
      {{ this.$props.title }}
    </div>
    <div
      class="image content"
      v-bind:class="{ scrolling: this.$props.scrolling }"
    >
      <div class="ui small image" v-if="this.$props.show_image">
        <img :src="this.$props.image" style="width: 100% !important" />
      </div>
      <slot></slot>
    </div>
    <div class="actions" v-if="show_ok || show_cancel">
      <div
        :class="
          'ui left floated icon right labeled button ' +
          button.color +
          ' ' +
          (button.visibility_condition === false ? 'hidden' : '')
        "
        v-for="(button, index) in this.$props.footer_buttons"
        v-bind:key="index"
        v-on:click="button.click"
      >
        <i :class="button.icon + ' icon'"></i>
        {{ button.text }}
      </div>
      <div
        class="ui red icon right labeled deny button"
        v-if="show_cancel != false"
      >
        <i class="remove icon"></i>
        {{ $t("cancel") }}
      </div>
      <div
        class="ui green right labeled icon button"
        v-on:click="finish"
        v-if="show_ok != false"
      >
        {{ $t("ok") }}
        <i class="checkmark icon"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { error_toast } from "../utils";

export default {
  data() {
    return {
      processing: false,
    };
  },
  props: {
    size: String,
    icon: String,
    title: String,
    image: String,
    footer_buttons: Array,
    on_finished: Function,
    scrolling: Boolean,
    show_ok: { type: Boolean, default: true },
    show_cancel: { type: Boolean, default: true },
    show_image: { type: Boolean, default: true },
  },
  mounted() {
    let vm = this;

    window
      // .jQuery(vm.$el)
      .jQuery(vm.$refs.generic_modal)
      .modal({
        allowMultiple: true,
        observeChanges: true,
        onShow() {},
        onVisible() {},
        onHidden() {
          vm.$emit("destroy");
          vm.$destroy();
        },
      })
      .modal("show");
  },
  methods: {
    finish() {
      let vm = this;
      vm.processing = true;
      if (this.$props.on_finished) {
        this.$props
          .on_finished()
          .then(() => {
            window.jQuery(vm.$el).modal("hide");
          })
          .catch((err) => {
            if (err) {
              error_toast(err);
              vm.processing = false;
            }
          })
          .finally(() => {
            vm.processing = false;
          });
      } else {
        vm.processing = false;
      }
    },
    set_loading(value) {
      this.processing = value;
    },
    hide() {
      window.jQuery(this.$el).modal("hide");
    },
  },
  watch: {},
};
</script>

<style scoped>
.content .description {
  width: 100% !important;
}
</style>
